<template>
  <div class="footer">
    <div>
      <div>
        <!-- <div>
          <div>{{ $t("footer.contactUs.self") }}</div>
          <div>{{ $t("footer.aboutUs.address-line1") }}</div>
          <div>{{ $t("footer.aboutUs.address-line2") }}</div>
          <div>Email: xiajing@jidcon.com</div>
        </div> -->
        <div
          v-for="group in footerGroups"
          :key="group.groupId || group.groupCode || group.groupName"
        >
          <div>{{ getGroupTitle(group) }}</div>
          <div
            v-for="item in group.items || []"
            :key="item.id || `${group.groupName}-${item.nameCn}-${item.url || item.itemType}`"
            :class="{ clickable: isLinkItem(item) }"
            @click="handleFooterItemClick(item)"
          >
            {{ getItemTitle(item) }}
          </div>
        </div>
        <!-- 关注我们 -->
        <div>
          <div>{{ $t("footer.followUs.self") }}</div>
          <div class="qrcode_container">
            <div>
              <img
                class="qrcode"
                referrerpolicy="no-referrer"
                :src="wxQrcode"
              >
              <span>{{ $t("footer.followUs.officialAccount") }}</span>
            </div>
            <div>
              <img
                class="qrcode"
                referrerpolicy="no-referrer"
                :src="wxVideoChannel"
              >
              <span>{{ $t("footer.followUs.wechatChannel") }}</span>
            </div>
            <div>
              <img
                class="qrcode"
                referrerpolicy="no-referrer"
                :src="appQrcode"
              >
              <span>{{ $t("footer.followUs.applets") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <a href="https://beian.miit.gov.cn/">©2022-{{ thisYear }} www.jidcon.com
          {{
            $t("footer.allRightsReserved")
          }}&nbsp;&nbsp;&nbsp;&nbsp;粤ICP备2021152175号-1
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { doGet } from "@/utils/http";

export default {
  name: "CommonFooter",
  data() {
    return {
      appQrcode: require("../assets/images/appQrcode.jpg"),
      wxQrcode: require("../assets/images/wxQrcode.png"),
      wxVideoChannel: require("../assets/images/wxVideoChannel.png"),
      footerGroups: [],
      thisYear: 2022,
    };
  },
  created() {
    this.getThisYear();
    this.getFooterLinks();
  },
  methods: {
    getThisYear() {
      let date = new Date();
      this.thisYear = date.getFullYear();
    },
    async getFooterLinks() {
      try {
        const res = await doGet("/home/footer-link/list");
        this.footerGroups = Array.isArray(res && res.data) ? res.data : [];
      } catch (error) {
        console.error("获取底部链接失败", error);
        this.footerGroups = [];
      }
    },
    getGroupTitle(group) {
      if (!group) {
        return "";
      }
      if (this.isEnglish() && group.nameEn) {
        return group.nameEn;
      }
      return group.groupName || group.nameCn || "";
    },
    getItemTitle(item) {
      if (!item) {
        return "";
      }
      if (this.isEnglish() && item.nameEn) {
        return item.nameEn;
      }
      return item.nameCn || item.nameEn || "";
    },
    isEnglish() {
      return (localStorage.getItem("lang") || "zh_CN") === "en_US";
    },
    isLinkItem(item) {
      return !!(item && item.itemType === "link" && item.url);
    },
    handleFooterItemClick(item) {
      if (!this.isLinkItem(item)) {
        return;
      }
      if (/^https?:\/\//i.test(item.url)) {
        window.open(item.url, "_blank");
        return;
      }
      const routeData = this.$router.resolve(item.url);
      window.open(routeData.href, "_blank");
    },
    openTyMall() {
      window.open("https://www.jbchip.com");
    },
  },
};
</script>

<style scoped lang="less">
.footer {
  height: 400px;
  background: #f3f5fa;
  > div {
    width: 1200px;
    margin: 0 auto;
    > div {
      display: flex;
      justify-content: space-between;
      a {
        font-family: Montserrat, Montserrat;
        font-weight: 300;
        font-size: 12px;
        color: #999999;
        margin-top: 80px;
        text-decoration: none;
      }

      > div {
        display: flex;
        flex-direction: column;
        > div:not(:first-child) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          margin-bottom: 13px;
          &.clickable {
            cursor: pointer;
          }
          &.clickable:hover {
            color: #103f9b;
          }
        }
        > div:nth-child(1) {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          margin-bottom: 16px;
          margin-top: 60px;
        }
        .qrcode_container {
          display: flex;
          > div {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-right: 18px;
            img {
              width: 103px;
              height: 103px;
              margin-bottom: 8px;
            }

            span {
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
